<template>
  <div
    class="page-panel"
    :class="{ shadow: shadow, overflow: overflow }"
    :style="panelStyle"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'panel',
  props: {
    padding: {
      type: [Number, Array],
      default: 0,
    },
    radius: {
      type: Number,
      default: 10,
    },
    shadow: {
      type: Boolean,
      default: true,
    },
    overflow: Boolean,
  },
  computed: {
    panelStyle() {
      if (this.padding == null) {
        return {}
      }
      if (typeof this.padding == 'number') {
        return {
          padding: this.padding + 'px',
          'border-radius': this.radius + 'px',
        }
      } else {
        return {
          padding: this.padding.map((item) => item + 'px').join(' '),
          'border-radius': this.radius + 'px',
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.page-panel {
  min-height: 0;
  height: 100%;
  flex: 1;
  background-color: #fff;
  border: 1px solid #EFEFF1;
  // &.shadow {
  //   box-shadow: 0px 2px 4px 0px rgba(199, 210, 230, 0.5);
  // }
  &.overflow {
    overflow: hidden;
    transform: rotate(0deg); //safari 兼容 overflow失效问题
  }
}
</style>
